"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InsightAction = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const merlin_button_1 = require("@travelnest/merlin.button");
const merlin_theme_1 = __importDefault(require("@travelnest/merlin.theme"));
const React = __importStar(require("react"));
const paintbrush_ladder_svg_1 = __importDefault(require("./92b3b47/assets/paintbrush-ladder.svg"));
const InfoPanel_1 = require("./InfoPanel");
const PaddingWrapper = styled_1.default.div `
	padding: 1.5rem;
	display: flex;
`;
const Image = styled_1.default.img `
	height: 3.5rem;
`;
const Content = styled_1.default.div({
    fontFamily: merlin_theme_1.default.typography.fonts.base,
    fontWeight: 400,
    fontSize: 16,
    lineHeight: '1.25rem',
    color: merlin_theme_1.default.palette.purple.dark,
    display: 'flex',
    flexDirection: 'column',
    marginLeft: '1.5rem',
});
const StyledButton = (0, styled_1.default)(merlin_button_1.Button) `
	margin-top: 1.5rem;
	font-family: ${merlin_theme_1.default.typography.fonts.base};
`;
const InsightAction = ({ text, onClick, buttonText, icon, widthOverride }) => {
    return (React.createElement(InfoPanel_1.InfoPanel, { colour: merlin_theme_1.default.palette.purple.tint, widthOverride: widthOverride },
        React.createElement(PaddingWrapper, null,
            React.createElement(Image, { role: "presentation", src: icon || paintbrush_ladder_svg_1.default }),
            React.createElement(Content, null,
                React.createElement("span", null, text),
                React.createElement("div", null,
                    React.createElement(StyledButton, { onClick: onClick, bgColor: merlin_theme_1.default.palette.purple.primary, color: merlin_theme_1.default.palette.greyscale.white }, buttonText))))));
};
exports.InsightAction = InsightAction;
//# sourceMappingURL=InsightAction.js.map